import { render, staticRenderFns } from "./VariantSelector.vue?vue&type=template&id=43db6a24&"
import script from "./VariantSelector.js?vue&type=script&lang=js&"
export * from "./VariantSelector.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports